const initialState = {
  numbers: [],
  locations: [],
  payGroups: [],
  timezones: [],
  selectedRows: [],
  initialFetchIsDone: false,
  loading: true,
  perPage: 20,
  page: 0,
  totalItems: 0,
  qs: "",
};

export default initialState;
